import { render } from "./CupCreationView.vue?vue&type=template&id=cf33dee8"
import script from "./CupCreationView.vue?vue&type=script&lang=js"
export * from "./CupCreationView.vue?vue&type=script&lang=js"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__